<template>
  <b-container fluid>
    <b-form @submit.stop.prevent="signup_email()">
      <b-form-group invalid-feedback="Must be greater then 4 character">
        <b-form-input v-model="email" type='email' required autocomplete="email" placeholder="Email"></b-form-input>
      </b-form-group>

      <b-form-group invalid-feedback="Must be greater then 4 character">
        <b-form-input v-model="password" type='password' required autocomplete="new-password" placeholder="Password"></b-form-input>
      </b-form-group>

      <b-form-group invalid-feedback="Must be greater then 4 character">
        <b-form-input v-model="name" required placeholder="Full name" autocomplete="name"></b-form-input>
      </b-form-group>

      <b-form-group invalid-feedback="Must be greater then 4 character">
        <b-form-input v-model="domain" type="url" required placeholder="Company domain" autocomplete="url"></b-form-input>
      </b-form-group>

      <LoadingButton variant="primary" block :loading="loading" @click="signup_email()">Signup</LoadingButton>
    </b-form>

    <b-button class='google-button  mt-3 mb-2' @click="signin_google" block><img class='google-logo' src="@/assets/google.svg" height="24px" width="24px"/> Signup with Google</b-button>

    <b-button :to='{name: "login_router"}' variant='link'>Login instead</b-button>
  </b-container>
</template>

<script>

import { db, auth } from '@/main.js'
import AuthMixin from "@/mixins/Auth.js"
import url from 'url'

export default {
  metaInfo: {title: 'Signup'},
  mixins: [AuthMixin],
  props: ['profile'],
  data() {
    return {
      email: this.$route.params.from_email || '',
      password: '',
      domain: '',
      name: '',
      loading: false
    }
  },
  methods: {
    async signup_email() {
      if (!this.name || this.name.length < 3 || this.name.trim().split(' ').length < 2) {
        return this.$swal({title: 'Try again', text: 'Please add your full name', icon: 'warning'})
      }

      let domain = this.domain.replace(/https?:\/\//ig, '').replace(/\//g, '').trim()
      if (!domain || domain.length < 3 || domain.split('.').length < 2) {
        return this.$swal({title: 'Try again', text: 'Please add your company domain', icon: 'warning'})
      }

      let result
      try {
        this.loading = true
        result = await auth.createUserWithEmailAndPassword(this.email, this.password)
      } catch (error) {
        this.loading = false
        return this.$swal({title: 'Try again', text: error.message, icon: 'warning'})
      }

      let user = result.user
      await this.create_account(user, {name: this.name, domain: domain})
    }
  },
}
</script>

<style scoped>

</style>
